<template>
  <el-dialog
    title="售后状态管理"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item label="订单号">
        <span>{{ formData.orderNo }}</span>
      </el-form-item>
      <el-form-item label="用户姓名">
        <span>{{ formData.memberName }}</span>
      </el-form-item>
      <el-form-item label="售后当前状态">
        <span>{{ formData.currentStatusName }}</span>
      </el-form-item>
      <el-form-item
        label="售后状态更新"
        prop="afterSaleStatus"
        :rules="[
          { required: true, message: '请选择售后状态', trigger: 'change' },
        ]"
      >
        <el-select
          v-model="formData.afterSaleStatus"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in afterSaleStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit"> 提交 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getAfterSaleStatusInfoAPI,
  updateAfterSaleStatusAPI,
} from "../api/after-sales";

export default {
  name: "AfterSalesStatus",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderNo: {
      type: String,
      default: "",
    },
    memberName: {
      type: String,
      default: "",
    },
    currentStatus: {
      type: [String, Number],
      default: "",
    },
    currentStatusName: {
      type: String,
      default: "",
    },
    // 售后状态选项
    afterSaleStatusOptions: {
      type: Array,
    },
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        orderNo: "",
        memberName: "",
        currentStatusName: "",
        afterSaleStatus: "",
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
        this.getStatusInfo();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
    orderNo(val) {
      if (this.dialogVisible) {
        this.formData.orderNo = val;
      }
    },
    memberName(val) {
      if (this.dialogVisible) {
        this.formData.memberName = val;
      }
    },
    currentStatusName(val) {
      if (this.dialogVisible) {
        this.formData.currentStatusName = val;
      }
    },
  },
  methods: {
    async getStatusInfo() {
      const res = await getAfterSaleStatusInfoAPI({
        orderNo: this.orderNo,
      });

      this.formData.orderNo = res.orderNo;
      this.formData.memberName = res.memberName;
      this.formData.currentStatusName = res.afterSaleStatusName;
      this.formData.afterSaleStatus = res.afterSaleStatus;
    },
    resetForm() {
      this.formData = {
        orderNo: this.orderNo || "",
        memberName: this.memberName || "",
        currentStatusName: this.currentStatusName || "",
        afterSaleStatus: "",
      };

      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await updateAfterSaleStatusAPI({
            orderNo: this.orderNo,
            afterSaleStatus: this.formData.afterSaleStatus,
          });

          this.$message.success("售后状态更新成功");

          this.handleClose();

          this.$emit("success", {
            afterSaleStatus: this.formData.afterSaleStatus,
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped></style>
